import type { PromptRequirements } from "@/lib/api/types";
import { demandLines } from "@/lib/prompt-module";

type Props = {
  req: PromptRequirements;
  /** Prompts, die das Suchvolumen bekämen (ohne Volumen, ohne verworfene, ggf. nur die gewählten). */
  count: number;
  /** Ob nur die gewählten Prompts betroffen sind. */
  chosen: boolean;
  busy: boolean;
  error: string | null;
  onStart: () => void;
  onCancel: () => void;
};

/** Rückfrage vor „Nachfrage ermitteln“: Weg über das Parent Topic und Kosten stehen vor dem Start da. */
export function DemandDialog({ req, count, chosen, busy, error, onStart, onCancel }: Props) {
  return (
    <div
      role="group"
      aria-label="Nachfrage ermitteln bestätigen"
      className="flex flex-col gap-3 rounded-lg border border-line bg-white px-5 py-4 text-sm"
    >
      <h2 className="text-base font-semibold">Nachfrage ermitteln?</h2>
      <p className="max-w-3xl text-[13px] text-muted">
        Der Nachfrage-Proxy im Score ist das Suchvolumen. Ausformulierte Fragen kennt ahrefs fast nie, deshalb geht es über das Parent Topic: Gemini
        formt aus dem Prompt den Suchbegriff, ahrefs nennt dazu das Parent Topic, und dessen Suchvolumen wird übernommen. Hat der Suchbegriff kein
        Parent Topic, gilt sein eigenes Volumen, kennt ahrefs ihn nicht, bleibt der Wert leer. Die Herkunft steht am Prompt.
      </p>
      <p className="text-[13px] text-muted">{chosen ? "Nur die gewählten Prompts ohne Suchvolumen." : "Alle Prompts des Topics ohne Suchvolumen (ohne verworfene)."}</p>
      <ul className="flex flex-col gap-0.5">
        {demandLines(req, count).map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
      {error && (
        <p role="alert" className="text-[13px] text-danger">
          {error}
        </p>
      )}
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          disabled={busy || count === 0}
          onClick={onStart}
          className="h-11 rounded-md bg-accent px-3.5 text-sm font-medium text-white disabled:opacity-60"
        >
          {busy ? "Wird gestartet …" : "Nachfrage ermitteln"}
        </button>
        <button type="button" onClick={onCancel} className="h-11 rounded-md border border-field bg-white px-3.5 text-sm">
          Abbrechen
        </button>
      </div>
    </div>
  );
}
